import React, { useContext } from 'react'
import { FormContext } from '../../context/form/FormContext';
import QuestionName from '../styleComponents/QuestionName';

const Scale = ({ id, question, qDescription, steps, answer, labels, page, setPage, limitPage  }) => {

  const { handleChange } = useContext(FormContext)

  const arraySteps = []
  if (steps) {
    for (let i = 0; i < steps; i++) {
      arraySteps.push(i)
    }
  }
  

  const general =  (id, event) => {
      handleChange(id,event)
      if(page !== limitPage){
        setPage(page + 1)
      }
  }


    return (
    <>
        <QuestionName questionName={question} description={qDescription}/>
        <div className={`d-flex overflow-auto gap-2 justify-content-between mx-auto scale_container ${arraySteps.length === 6 ? 'small' : 'large'}`}>
        {
          arraySteps.map((step, i) => {
            let value = i + 1
            return <div key={`${value}${question}`}>
            <input 
              className={`scale__input ${answer === value ? 'scale__input-active' : ''}`}
              id={`${value}${question}`}
              type='button' 
              name={question} 
              value={value} 
              onClick={() => general(id, {target: {value}})}
              />
          </div>
          })
        }
        </div>
        {
          labels && labels.length >= 0 &&
          <div className={`d-flex justify-content-between pt-2 p-4 mx-auto mb-5 scale_labels ${arraySteps.length === 6 ? 'small' : 'large'}`}>
            <p>{labels[0] && labels[0] }</p>
            <p>{labels[1] && labels[1] }</p>
            <p>{labels[2] && labels[2] }</p>
        </div>
        }
</>
    )
}

export default Scale

